import styled, {css} from 'styled-components'
import {SelectItem} from '@components/ui/select-atoms/SelectAtoms.tsx'

export const StyledSelectItem = styled(SelectItem)(
    ({theme: {spacing}}) => css`
        & .content {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            gap: ${spacing * 2}px;
        }
    `
)
